'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

var _listedEvent = require('../events/listed.event.medallion');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _asyncToGenerator3.default)(
/*#__PURE__*/
_regenerator2.default.mark(function _callee() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var response;
  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _f3tch2.default)('/medallions/').profile('json').query(query).get();

        case 2:
          response = _context.sent;

          _listedEvent.pub.apply(undefined, (0, _toConsumableArray3.default)(response.results));

          return _context.abrupt('return', response);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, undefined);
})); // Events